__turbopack_context__.v({
  "clockIcon": "Status-module__vFy_7G__clockIcon",
  "eddContainer": "Status-module__vFy_7G__eddContainer",
  "statusText": "Status-module__vFy_7G__statusText",
});
